import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRateSelectorAction } from "data/lockSummary/actionCreators";
import { DSSeparator } from "@elliemae/ds-separator";
import {
  StyledEppsParentView,
  StyledEppsContainerBody,
  StyledEppsWrapper,
} from "view/global/styles/styled";
import { isShallowEqual } from "utils/shared";
import { DataProvider } from "utils/customHooks/useAppData";
import DiffElements from "./components/DiffElements";
import PricingTable from "./components/PricingTable";
import SummaryHeader from "./components/SummaryHeader";
import CommentsSection from "./components/CommentsSection";
import FooterActionButtons from "./components/FooterActionButtons";
import GeneralLoanInformation from "./components/GeneralLoanInformation/GeneralLoanInformation";
import InformationGroupSection from "./components/InformationGroupSection";
import StatusFailMessage from "./components/SummaryHeader/StatusFailMessage";
import { getTableDataWithIDs } from "./components/PricingDetailsModal/helpers";

const LockSummary = () => {
  const [dataTableContext, setTableDataContext] = useState({
    rawPrice: [],
    adjustedPrice: [],
  });
  const dispatch = useDispatch();
  const priceData = useSelector(
    ({
      epps: {
        lockSummary: { rateSelector },
      },
    }) => rateSelector.priceData,
    isShallowEqual
  );

  useEffect(() => {
    // TODO This code snippet was changed and needs to be refactored.
    if (priceData) setTableDataContext(getTableDataWithIDs(priceData));
  }, [priceData]);

  const initPage = async () => {
    await dispatch(getRateSelectorAction());
  };

  useEffect(() => {
    initPage();
    window.scrollTo(0, 0);
  }, []);

  return (
    <StyledEppsParentView>
      <StatusFailMessage />
      <StyledEppsContainerBody>
        <StyledEppsWrapper>
          <DataProvider
            value={{
              dataTableContext,
              setTableDataContext,
            }}
          >
            <SummaryHeader />
            <GeneralLoanInformation />
            <DSSeparator
              margin="s"
              type="non-form"
              orientation="horizontal"
              position="initial"
            />
            <PricingTable />
            <InformationGroupSection />
            <CommentsSection />
          </DataProvider>
        </StyledEppsWrapper>
      </StyledEppsContainerBody>
      <FooterActionButtons />
      <DiffElements />
    </StyledEppsParentView>
  );
};

export default LockSummary;
